/*
 * Sharing the page (More → Share): the device's share sheet with the page's own title, description and clean address
 * (its short link where it has one, tcr.onl/s/…, else its canonical link: no tracking, and no #tab unless the tab is
 * marked data-share); where there's no share
 * sheet, the link is copied instead.
 */
const content = (selector) => document.querySelector(selector)?.getAttribute('content')
    || document.querySelector(selector)?.getAttribute('href') || null;

window.share = async () => {
    // A tab worth sharing as it is (data-share: a stallion's Directory listing) keeps its #
    const tab = location.hash.slice(1);
    const hash = tab && document.querySelector(`[data-tab="${CSS.escape(tab)}"][data-share]`) ? location.hash : '';
    const url = (content('link[rel=shortlink]') || content('link[rel=canonical]') || location.href.split('#')[0]) + hash;
    // "Blog - The Traditional Cob Registry" → "Blog": the link preview names the site already
    const title = (content('meta[property="og:title"]') || document.title).replace(/\s-\s[^-]+$/, '');
    const text = content('meta[property="og:description"]') || '';

    if (navigator.share) {
        try {
            return await navigator.share({title, text, url});
        } catch (error) {
            if (error.name === 'AbortError') return;    // closed the share sheet
        }
    }

    try {
        await navigator.clipboard.writeText(url);
        window.Toaster?.success('Link copied.');
    } catch (e) {
        window.Toaster?.error('Couldn\'t copy the link.');
    }
};
